import { render, staticRenderFns } from "./VodFlux.vue?vue&type=template&id=3f2e3f5e&scoped=true"
import script from "./VodFlux.vue?vue&type=script&lang=js"
export * from "./VodFlux.vue?vue&type=script&lang=js"
import style0 from "./VodFlux.vue?vue&type=style&index=0&id=3f2e3f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e3f5e",
  null
  
)

export default component.exports